module.exports = new __parcel__URL__("miracle-screenshot.ae10c03e.png").toString();